import Vue from 'vue'

const EXPORT = {
	POST: filter => {
		return Vue.$api.get('/export/post', {
			params: { filter: filter },
		})
	},
}

export default EXPORT
